// @flow
import React from 'react'
import glamorous from 'glamorous'
import Helmet from 'react-helmet'
import { Markdown, BackgroundImage } from 'components'
import { border, colors, padding, margin, typography } from 'style'

import type { Location } from 'react-router-dom'
import type { ContentfulSizes } from 'types'

type ContentfulPage = {
  title: string,
  featuredImage: {
    title: string,
    sizes: ContentfulSizes,
  },
  body: {
    childMarkdownRemark: {
      html: string,
    },
  },
}

const Header = glamorous.div({
  ...border.bottom({ color: colors.gray200 }),
  ...margin.bottom(5),
  ...padding.x(3),
  display: 'flex',
  minHeight: 340,
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: colors.gray100,
  position: 'relative',
  zIndex: 0,
  overflow: 'hidden',
})

const Title = glamorous.h1({
  ...typography.largeTitle,
  color: colors.white,
})

type Props = {
  location: Location,
  data: {
    contentfulPage: ContentfulPage,
    site: {
      siteMetadata: {
        siteUrl: string,
      },
    },
  },
}

const PageTemplate = ({ data, location }: Props) => {
  const page = data.contentfulPage
  const { siteUrl } = data.site.siteMetadata
  return (
    <article style={{ ...padding.bottom(5) }}>
      <Helmet>
        <title>{page.title}</title>
        <link
          rel="canonical"
          href={`${siteUrl}${location.pathname.replace(/\/$/, '')}`}
        />
      </Helmet>
      <Header>
        <BackgroundImage
          sizes={page.featuredImage.sizes}
          alt={page.featuredImage.title}
        />
        <Title>{page.title}</Title>
      </Header>
      <Markdown
        alignCenter={location.pathname === '/contact'}
        dangerouslySetInnerHTML={{
          __html: page.body.childMarkdownRemark.html,
        }}
      />
    </article>
  )
}

export default PageTemplate

export const pageQuery = graphql`
  query PageTemplateQuery($id: String!) {
    contentfulPage(id: { eq: $id }) {
      title
      featuredImage {
        title
        sizes(quality: 80) {
          ...GatsbyContentfulSizes_withWebp
        }
      }
      body {
        childMarkdownRemark {
          html
        }
      }
    }
    ...SiteUrl
  }
`



// WEBPACK FOOTER //
// ./src/templates/page.js